import { styled } from '@mui/material';
import { Event } from 'services/api';

export interface EventStatusStyleProps {
  status: Event['status'];
}

export const EventStatus = styled('div')(
  ({ status }: EventStatusStyleProps) => {
    const color =
      status === 'PENDING_APPROVAL'
        ? '#F25C05'
        : status === 'PUBLISHED'
        ? '#00980B'
        : status === 'CANCELLED' || status === 'EXPIRED'
        ? '#383838'
        : status === 'REJECTED'
        ? '#F25C05'
        : status === 'UPDATED'
        ? '#008BF5'
        : status === 'RESCHEDULED'
        ? '#008BF5'
        : 'inherit';

    return {
      padding: '7px 15px',
      fontSize: '0.875em',
      fontWeight: 500,
      textAlign: 'center',
      borderLeft: `2px solid ${color}`,
      background:
        status === 'PENDING_APPROVAL'
          ? '#FEEEE5'
          : status === 'PUBLISHED'
          ? '#E7F9F1'
          : status === 'CANCELLED' || status === 'EXPIRED'
          ? '#F5F5F5'
          : status === 'REJECTED'
          ? '#FEEEE5'
          : status === 'UPDATED'
          ? '#EBF1F8'
          : status === 'RESCHEDULED'
          ? '#EBF1F8'
          : 'none',
      color,
    };
  },
);
